export const getFrankyData = ( state ) => {
    return state.franky
}
